









































































import { Vue, Component } from 'vue-property-decorator'
import { WingBlank, MainHead, HeadTabs, RunStatusAll } from '@/components/index'

import { GroupPage } from '@/api/GroupAdmin'
import { EnableList } from '@/api/ObectAdmin'
import { ReqGroupPage } from '@/types/GroupAdmin'

@Component({
  components: {
    WingBlank,
    MainHead,
    HeadTabs,
    RunStatusAll
  },
})
export default class MainCon extends Vue {
  /**
   * tabsActive 切换 客户 员工
   * statusArr 搜索时切换状态
   * name      搜索时输入框内容
   *
   * tableData   表格数据
   * currentPage 分页当前页数
   */

  /**
   * 方法
   *
   * getEnableList  获取tab数据
   * getGroupPage   获取分页数据
   * handlClickTabs  点击tab切换
   * handleClickStatus 点击状态切换
   *
   */
  // 头部数据
  headData: string[] = [
    '创建并维护各对象的分群，并对分群中的对象实例进行分析。',
    '在创建和维护分群前，请先选择对象：',
  ];
  headTitle: string = '分群列表';
  HeadImg: string = require('@/assets/images/u28.png');
  // tab切换数据
  tabsArr: string[] = [];
  tabsActive: number = 0;

  /**
   * 全部  ’‘ 不传
   *
   * 运行中     1
   * 停用       2
   * 已结束     3
   * 未开始     4
   */

  statusArr: string[] = ['全部', '运行中', '停用', '已结束', '未开始'];

  form: ReqGroupPage = {
    status: 0,
    name: '',
    current: 1,
    size: 10,
    objectId: 1,
  };
  // 表格数据
  tableData: any[] = [];
  // 分页数据
  total = 0

  created() {
    this.getEnableList()
  }
  async getEnableList() {
    const { data } = await EnableList()
    this.tabsArr = data
    // this.form.objectId = data[0].id
    this.getGroupPage()
  }
  async getGroupPage() {
    const form = { ...this.form }
    form.status = form.status === 0 ? '' : form.status
    const { data } = await GroupPage(form)
    this.tableData = data.records
    this.total = data.total
  }

  handlClickTabs(idx: number, item: any) {
    this.form.objectId = item.id
    this.form.current = 1
    this.tabsActive = idx
    this.getGroupPage()
  }

  // 点击状态切换
  handleClickStatus(idx: number) {
    this.form.status = idx
    this.form.current = 1
    this.getGroupPage()
  }
  handleSizeChange(val: number) {
    this.form.size = val
    this.getGroupPage()
  }
  handleCurrentChange(val: number) {
    this.form.current = val
    this.getGroupPage()
  }
  // 点击当前行
  handleclickRow(row: any) {
    this.$router.push({
      path: '/group/detail',
      query: {
        id: row.id,
      },
    })
  }
  // 创建分群
  createGropu() {
    const { tabsArr, tabsActive } = this
    this.$router.push({
      path: '/group/add',
      query: {
        id: (tabsArr[tabsActive] as any).id,
        name: (tabsArr[tabsActive] as any).name
      }})
  }
}
